import React, { useState, useEffect } from 'react';
import { Code2 } from 'lucide-react';

import {
  Modal,
  Input,
  FormField,
  Button,
} from "../../design-system";

const IframeModal = ({ isOpen, onClose, onInsert }) => {
  const [iframeUrl, setIframeUrl] = useState('');
  const [width, setWidth] = useState('100%');
  const [height, setHeight] = useState('400');

  useEffect(() => {
    if (!isOpen) {
      setIframeUrl('');
      setWidth('100%');
      setHeight('400');
    }
  }, [isOpen]);

  const handleClose = () => onClose();

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (iframeUrl.trim()) {
      onInsert({
        src: iframeUrl.trim(),
        width: width || '100%',
        height: height || '400',
        frameborder: '0',
        allowfullscreen: true,
      });
      handleClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="lg"
      title="Ajouter un iframe"
      footer={
        <>
          <Button variant="ghost" onClick={handleClose}>Annuler</Button>
          <Button
            onClick={handleSubmit}
            isDisabled={!iframeUrl.trim()}
            leftIcon={<Code2 className="w-4 h-4" strokeWidth={1.8} />}
          >
            Insérer l'iframe
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormField
          label="URL de l'iframe"
          required
          helper="YouTube, Vimeo, Codesandbox, etc. — colle l'URL d'embed."
        >
          <Input
            type="url"
            placeholder="https://example.com/embed/…"
            value={iframeUrl}
            onChange={(e) => setIframeUrl(e.target.value)}
            autoFocus
          />
        </FormField>

        <div className="grid grid-cols-2 gap-3">
          <FormField label="Largeur" helper="Ex : 100%, 800px">
            <Input
              type="text"
              placeholder="100%"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
            />
          </FormField>
          <FormField label="Hauteur" helper="Ex : 400, 600px">
            <Input
              type="text"
              placeholder="400"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
            />
          </FormField>
        </div>
      </form>
    </Modal>
  );
};

export default IframeModal;
